import React from 'react';
import { navigate } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { makeStyles } from '@material-ui/core/styles';
import { Card, Typography, Grid } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const useStyles = makeStyles((theme) => ({
	root: {
		color: theme.workwaveBlue,
		minHeight: '305px',
		maxWidth: '380px',
		position: 'relative',
		paddingTop: '2.75rem',
    borderRadius: '8px',
		marginBottom: '25px',
		transition: 'transform 0.25s, box-shadow 0.75s',
		boxShadow:
			'0 13px 27px -5px rgba(50, 50, 93, 0), 0 8px 16px -8px rgba(0, 0, 0, 0)',

		'&:hover': {
			transform: 'scale(1.02)',
			transition: 'transform 0.25s, box-shadow 0.75s',
			cursor: 'pointer',
			boxShadow:
				'0 13px 27px -5px rgba(50, 50, 93, 0.2), 0 8px 16px -8px rgba(0, 0, 0, 0.3)',
		},

    [theme.breakpoints.up('lg')]: {
			maxWidth: '380px',
		},
		[theme.breakpoints.up('md')]: {
			maxWidth: '345px',
      minHeight: '325px',
		},
		[theme.breakpoints.down('sm')]: {
			maxWidth: '380px',
      minHeight: '325px',
		},
    [theme.breakpoints.down('xs')]: {
      marginLeft: '0px !important',
			marginRight: '0px !important',
    },
	},
	title: {
		fontSize: 16,
		fontWeight: 'bold',
		color: theme.workwaveBlue,
		textAlign: 'center',
		margin: '2rem 0 0.5rem 0',
	},
	pos: {
		marginBottom: 12,
		color: theme.workwaveBlue,
		textAlign: 'center',
		color: '#5A7184',
    fontFamily: ['Roboto', 'sans-serif'].join(),
    lineHeight: 1.4,
	},
	icon: {
		border: `1px solid #F1F2F5`,
		background: '#F1F2F5',
		borderRadius: '15px',
		padding: '.5rem',
		maxHeight: '50px',
		maxWidth: '50px',
	},
	// HomeCardLogoProduct: {
	// 	minHeight: '50px',
	// 	width: 'auto',
	// 	height: '50px !important',
	// },
	HomeCardLogoPartner: {
		maxWidth: '100%',
		minHeight: '50px',
		// height: '50px !important',
	},

	promoText: {
		color: '#fff',
		background: '#19305A',
		padding: '3px 5px',
		fontSize: '16px',
		lineHeight: '16px',
		fontWeight: '600',
		position: 'absolute',
		top: '-12px',
		right: '15px',

		'&::before': {
			borderRight: '10px solid #19305A',
			borderTop: '11px solid transparent',
			content: '""',
			display: 'block',
			height: '0',
			left: '-10px',
			position: 'absolute',
			top: '0',
			width: '7px',
			opacity: '0.7',
		},
	},
	affiliateText: {
		color: '#fff',
		background: '#055291',
		padding: '3px 5px',
		fontSize: '16px',
		lineHeight: '16px',
		fontWeight: '600',
		position: 'absolute',
		top: '-12px',
		right: '15px',

		'&::before': {
			borderRight: '10px solid #055291',
			borderTop: '11px solid transparent',
			content: '""',
			display: 'block',
			height: '0',
			left: '-10px',
			position: 'absolute',
			top: '0',
			width: '7px',
			opacity: '0.7',
		},
	},
  arrow: {
		marginLeft: '.25rem',
		transition: 'transform .25s ease-in-out',
		display: 'inline-block',
	},
	ctaLink: {
		marginBottom: '.5rem',
    textAlign: 'center',
		'&:hover': {
			'& $arrow': { transform: 'translateX(10px)' },
		},
	},
}));

export const FeaturedPartnerCard = ({
	name,
	body,
	slug,
	logo,
	promo,
	affiliateLink,
}) => {
	const classes = useStyles();

	const handleClick = (e) => {
		e.preventDefault();

		typeof window !== 'undefined' && window.open(slug, '_blank');
	};

	const lg = useMediaQuery('(max-width: 1280px)');
  const sm = useMediaQuery('(max-width: 715px)');
	return (
		<Grid
			item
			component={Card}
			variant='outlined'
			xs={12}
      sm={6}
			md={4}
			className={classes.root}
			//this is where the styles should change based on the promo prop
			style={{
				border: promo && '1px dashed #19305A',
				overflow: (promo || affiliateLink) && 'visible',
			}}
			onClick={(e) => handleClick(e)}>
			<Grid
				container
				direction='column'
				justify='flex-start'
				alignItems='center'
				style={{ height: '100%' }}>
				<GatsbyImage
					image={logo.asset?.gatsbyImageData}
					className={classes.HomeCardLogoPartner}
					alt='partner-logo'
					style={{ maxWidth: '100%' }}
				/>
				<Typography className={classes.title}>{name}</Typography>
				<Typography variant='body2' component='p' className={classes.pos}>
					{body}
				</Typography>{' '}
				{!!promo ? (
					<Typography className={classes.promoText}> SPECIAL OFFER </Typography>
				) : !!affiliateLink ? (
					<Typography className={classes.affiliateText}>
						{' '}
						AFFILIATE OFFER{' '}
					</Typography>
				) : null}
        <Grid item style={{ position: 'absolute', bottom: 0, paddingBottom: '1rem' }}>
          <Typography
            variant='body2'
            className={classes.ctaLink}
            style={{
              color: '#002D5C',
              fontWeight: 700,
              fontSize: '1.125rem',
              marginTop: sm && '1rem',
            }}>
            Learn More
            <span className={classes.arrow}>→</span>
          </Typography>
        </Grid>
			</Grid>
		</Grid>
	);
};
